module.exports = __webpack_public_path__ + "svg/fer.229ec41.svg";